import { useMediaQuery } from './useMediaQuery';
import { useSettings } from './settings';
import { resolveEffectiveReducedMotion } from './game/motion';

/** PART 4: the one effective reduced-motion boolean, combining the user's
 * manual `Settings.reducedMotion` choice with the live OS
 * `prefers-reduced-motion` query -- see game/motion.ts's
 * `resolveEffectiveReducedMotion` for the pure auto/on/off resolution this
 * just threads live values into. Reactive to BOTH a settings write (any
 * caller, via `useSettings`'s shared store) and an OS-level preference
 * change (via `useMediaQuery`'s own 'change' listener). */
export function useEffectiveReducedMotion(): boolean {
  const [settings] = useSettings();
  const osPrefersReduced = useMediaQuery('(prefers-reduced-motion: reduce)');
  return resolveEffectiveReducedMotion(settings.reducedMotion, osPrefersReduced);
}
